<template>
  <div class="cover flex-col">
    <el-row class="head flex" style="height: 3rem">
      <div
        class="justify-between align-center"
        @mouseenter="clearmenuListPositon()"
      >
        <div class="align-center">
          <!-- v-if="catalogueList.length" -->
          <!-- <el-pagination
            @current-change="handleCurrentChange"
            :page-size="1"
            :current-page="bookParam.juanNum * 1"
            :small="true"
            layout="prev, pager, next"
            :total="catalogueList.length"
          >
          </el-pagination>
          <div style="font-size: 0.8rem">共{{ catalogueList.length }}卷</div> -->
        </div>
        <div v-if="catalogueList.length" style="width: 74%; text-align: center">
          <div class="align-center justify-center">
            <el-tooltip content="上一種" placement="top" effect="light">
              <img
                class="nexticon leftnext"
                src="/static/icon/next2.png"
                alt=""
                @click="nextbook(1)"
              />
            </el-tooltip>
            <span>{{ bookdetail.bookName }}</span>
            <el-tooltip content="下一種" placement="top" effect="light">
              <img
                class="nexticon xuanzhuan"
                src="/static/icon/next2.png"
                alt=""
                @click="nextbook(2)"
              />
            </el-tooltip>
          </div>
          /
          {{ catalogueList[bookParam.juanNum - 1].catalogName }}
          {{ secondTitle ? "/ " + secondTitle : "" }}
        </div>
        <div class="justify-between align-center">
          <el-tooltip
            content="放大"
            style="color: #eee"
            placement="bottom"
            effect="light"
          >
            <img
              src="/static/icon/scale+.png"
              class="icon kuo"
              @click="fontSize += 3"
            />
          </el-tooltip>
          <el-tooltip content="縮小" placement="bottom" effect="light">
            <img
              src="/static/icon/scale-.png"
              class="icon suo"
              @click="fontSize > 0 && (fontSize -= 3)"
            />
          </el-tooltip>
          <!-- <img src="/static/icon/edite.png" class="icon" /> -->
          <el-tooltip
            :content="isVertical ? '横板' : '豎版'"
            placement="bottom"
            effect="light"
          >
            <img
              :src="
                isVertical
                  ? '/static/icon/horizontal.png'
                  : '/static/icon/vertical1.png'
              "
              class="icon"
              @click="changeVertical()"
            />
          </el-tooltip>
          <!-- <el-tooltip placement="bottom" effect="light" content="圖像">
            <el-image
              class="icon"
              src="/static/icon/pdf2.png"
              :preview-src-list="pdfList"
            >
            </el-image>
          </el-tooltip> -->
          <span class="bg-color-box">
            <el-tooltip content="切换背景" placement="bottom" effect="light">
              <img
                src="/static/icon/bg-status2.png"
                @click="isSelectColor = !isSelectColor"
                class="icon"
              />
            </el-tooltip>
            <el-card class="colors-box" v-if="isSelectColor">
              <div
                v-for="(item, key) in colors"
                @click="(e) => setViewBgColor(e, key)"
                :style="{
                  background: item.b,
                  zIndex: 9999,
                  'text-align': 'center',
                }"
                :key="item.b"
              >
                {{ item.name }}
              </div>
            </el-card>
          </span>
        </div>
      </div>
      <div v-if="opeatMenuSltType != 1" class="align-center">
        <el-input
          style="width: 200px"
          v-model="newParam.keyword"
          size="small"
          @keyup.enter.native="topSearch"
          placeholder="書内檢索"
        >
          <el-button
            slot="append"
            size="small"
            icon="el-icon-search"
            @click="topSearch"
          ></el-button>
        </el-input>
      </div>
      <div v-else style="width: 200px"></div>
    </el-row>
    <div
      class="flex flex-grow relative"
      id="contentBox"
      :style="{ cursor: rightOpera.isMouseDown ? 'ew-resize' : '' }"
      @mousemove="moveClient"
      @mouseup="mouseUp"
    >
      <img
        class="open-icon"
        v-if="!isLeftTree"
        src="/static/icon/right.png"
        style="left: 24px"
        @click="isLeftTree = !isLeftTree"
      />

      <img
        class="open-icon"
        v-if="!isOperaText"
        src="/static/icon/left.png"
        @click="isOperaText = true"
      />
      <div
        class="tree-list"
        v-show="isLeftTree"
        ref="leftDragCate"
        @mouseenter="clearmenuListPositon()"
      >
        <div
          class="drag-box"
          @mousedown="getClientInfo($event, 'leftDragCate')"
        ></div>

        <div class="justify-between align-center">
          <div></div>
          <!-- <el-link  :underline="false">目录</el-link> -->
          <img
            src="/static/icon/left.png"
            class=""
            @click="isLeftTree = !isLeftTree"
          />
        </div>
        <div class="tree">
          <div class="quanKuBtn justify-between">
            <el-button
              size="small"
              :type="isQuanKu ? 'primary' : ''"
              round
              @click="isQuanKu = !isQuanKu"
              >全庫目録</el-button
            >
            <el-button
              size="small"
              :type="!isQuanKu ? 'primary' : ''"
              round
              @click="isQuanKu = !isQuanKu"
              >本書目録</el-button
            >
          </div>
          <div v-if="!isQuanKu" class="align-center title">
            <i
              :class="
                selectTreeIndex ? 'el-icon-caret-bottom' : 'el-icon-caret-right'
              "
              @click="changeTreeIndex()"
              class="right-icon"
            ></i>

            <el-tooltip content="文獻詳情" placement="right" effect="light">
              <span class="overhand" @click="gotoBookDetail()">
                {{ bookdetail.bookName }}</span
              >
            </el-tooltip>
          </div>
          <div v-if="!isQuanKu" class="treeoutdiv">
            <transition name="fade-in">
              <el-tree
                :data="catalogueList"
                :props="defaultProps"
                @node-click="treeNodeClick"
                style="height: max-content; width: max-content"
                node-key="catalogId"
                ref="leftCatalogList"
                :highlight-current="true"
                :current-node-key="bookParam.catalogId * 1"
              >
                <!--
              :indent="0"
              icon-class="''" -->
                <span
                  class="custom-tree-node"
                  slot-scope="{ node, data }"
                  :style="{
                    paddingLeft:
                      (data.level - node.parent.level - 1) * 18 + 'px',
                  }"
                >
                  <!-- <span
                  :class="[
                    'el-icon-caret-right',
                    'el-tree-node__expand-icon',
                    node.expanded ? 'expanded' : '',
                    node.childNodes.length ? '' : 'is-leaf',
                  ]"
                  style="padding: 6px"
                ></span> -->

                  <span
                    class="el-tree-node__label"
                    :id="'tree' + data.catalogId"
                  >
                    {{ node.label }}
                  </span>
                  <span
                    class="xinghao"
                    v-show="catalogIdList.includes(data.catalogId)"
                    >*</span
                  >
                </span>
              </el-tree>
            </transition>
          </div>
          <booksTree v-show="isQuanKu" />
        </div>
      </div>

      <!-- 文档内容展示height: 'calc(100vh - 11.29rem - 32px)', margin: isVertical?'42px 0 0':'32px 0 0', -->
      <div
        class="flex-grow scrolltotop"
        id="bookContentBox"
        @resize="getContentBoxWidth"
        @scroll="getViewInCatelogInfo"
        @mousewheel="getContentBoxWheel"
        :style="{
          padding: '40px',
          writingMode: isVertical ? 'vertical-rl' : '',
          overflow: 'auto',
          overflowX: isVertical ? '' : 'hidden',
          overflowY: isVertical ? 'hidden' : '',
          height: 'calc(100vh - 8rem)',
          background: colors[themeId].b,
          color: colors[themeId].f,
          wordBreak: 'normal',
          textAlign: 'justify',
          whiteSpace: 'pre-wrap',
          fontSize: 0,
        }"
      >
        <!-- class="cover" -->
        <div :style="isVertical ? 'height: 100%' : 'width: 100%;height: 100%'">
          <xml-tree
            :node-list="nodeList"
            :book-name="bookPath"
            :passageXmlId="passageXmlId"
            :keyword="opeatMenuSltType == 1 ? keywordStr : ''"
            :searchAccuracyType="bookParam.searchAccuracyType"
            :noteOrQa="noteOrQa"
            :myBookMarkMap="myBookMarkMap"
            :underline="underline"
            :isBlock="true"
            node-label="段落"
            :indent-type="'正文1'"
            :isVertical="isVertical"
            :fontSize="fontSize"
            :fontInitSize="26"
            @select="getSelectData"
            :selectNoteData="selectNoteData"
          ></xml-tree>
          <div
            class="cunmuicon"
            v-if="bookdetail.bookLinkVo"
            @click="cunmutopath"
          >
            <img src="/static/icon/hreficonnew.png" alt="" />
          </div>
          <div
            :style="{
              width: isVertical ? '40px' : '100%',
              height: isVertical ? '100%' : '40px',
            }"
          >
            <span></span>
          </div>
        </div>
      </div>

      <!-- 文档内容操作区域 -->
      <div
        class="text-opera"
        v-show="isOperaText"
        ref="opearBox"
        id="opearBox"
        @mouseup="mouseUp"
        @mouseenter="clearmenuListPositon()"
      >
        <div
          class="drag-box"
          @mousedown="getClientInfo($event, 'opearBox')"
        ></div>
        <el-card style="height: 100%">
          <img
            src="/static/icon/right1.png"
            @click="isOperaText = false"
            class="recover-btn"
          />

          <div class="left-menu">
            <div
              class="item"
              v-for="item in opearMenuList"
              :class="opeatMenuSltType == item.key && 'active'"
              @click="opeatMenuSltType = item.key"
              :key="item.text"
            >
              <img
                :id="item.id + 'img'"
                :src="
                  '/static/icon/' +
                  (opeatMenuSltType == item.key ? item.activeIcon : item.icon)
                "
              />
              <span :id="item.id">{{ item.text }}</span>
            </div>
          </div>
          <div class="cover flex-grow opear-box">
            <template v-if="opeatMenuSltType == 0">
              <div class="justify-between">
                <span
                  ><i
                    class="el-icon-info"
                    style="
                      color: #cc3333;
                      font-size: 1.15rem;
                      margin-right: 0.3rem;
                    "
                  ></i
                  >校記</span
                >
                <div>
                  <img
                    src="/static/icon/scale+.png"
                    class="scalicon kuo"
                    alt=""
                    @click="changefontSize += 3"
                  />
                  <img
                    src="/static/icon/scale-.png"
                    class="scalicon kuo"
                    alt=""
                    @click="changefontSize > 0 && (changefontSize -= 3)"
                  />
                </div>
              </div>
              <el-collapse class="list-box" value="1">
                <el-collapse-item
                  :title="`共${footNoteList.length}項`"
                  name="1"
                >
                  <ul class="old-list">
                    <li
                      v-for="(item, index) in footNoteList"
                      :id="'x' + item.id"
                      :key="item.id"
                      :class="xiaoOpearListId === item.id && 'active'"
                      @click="
                        rightCatalogId = item.catalogId;
                        xiaoOpearListId = item.id;
                        viewFootNoteIcon(item.id);
                      "
                    >
                      <span class="sort">{{ index + 1 }}.</span>
                      <div
                        class="list-content"
                        :style="{
                          fontSize: 16 * (1 + changefontSize / 100) + 'px',
                        }"
                      >
                        <span></span>
                        <i
                          class="el-icon-info"
                          style="color: rgb(204, 51, 51)"
                        ></i>
                        <!-- <span v-html="item.content"></span> -->
                        <footNote
                          :footList="item.content"
                          :changefontSize="changefontSize"
                          :keyword="keyword"
                          :bookName="bookPath"
                          lablefont="m"
                        ></footNote>
                      </div>
                    </li>
                  </ul>
                </el-collapse-item>
              </el-collapse>
            </template>
            <template v-if="opeatMenuSltType == 1">
              <!-- <el-input
                placeholder="請輸入内容"
                @keyup.enter.native="searchDataInBook"
                v-model="keyword"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="searchDataInBook"
                ></el-button>
              </el-input> -->
              <div class="search-box">
                <div class="justify-between content">
                  <div class="left-input-box">
                    <div class="align-center input-select">
                      <el-input
                        placeholder="請輸入内容"
                        v-model="newParam.keyword"
                        class="input-select"
                        @click.stop.native
                        @keyup.enter.native="clickSearch(true)"
                        style="margin-bottom: 0.5rem"
                      >
                        <el-select
                          v-model="newParam.searchType"
                          slot="prepend"
                          placeholder="請選擇"
                          style="width: 106px"
                        >
                          <el-option label="一般檢索" value="0"></el-option>
                          <el-option label="進階檢索" value="1"></el-option>
                          <el-option label="NEAR檢索" value="2"></el-option>
                        </el-select>
                        <el-button
                          slot="append"
                          icon="el-icon-search"
                          @click="viewDetail"
                        ></el-button>
                      </el-input>
                      <!-- searchDataInBook -->
                      <!-- <el-button
            type="primary"
            class="submit-btn"
            :icon="loading ? 'el-icon-loading' : ''"
            round
            @click.stop="clickSearch(true)"
          >
            <img
              v-if="!loading"
              style="height: 1rem; width: auto"
              src="/static/search.png"
              alt=""
            />
          </el-button> -->
                    </div>
                    <template v-if="newParam.searchType === '1'">
                      <el-input
                        v-for="(item, index) in advancedQuery"
                        :key="index + 'ad'"
                        placeholder="請輸入内容"
                        @click.stop.native
                        v-model="item.keyword"
                        @keyup.enter.native="clickSearch(true)"
                        class="input-select"
                        style="margin-bottom: 0.5rem"
                      >
                        <el-select
                          v-model="item.type"
                          style="width: 80px"
                          slot="prepend"
                          placeholder="請選擇"
                        >
                          <el-option label="OR" value="or"></el-option>
                          <el-option label="AND" value="and"></el-option>
                          <el-option label="NOT" value="not"></el-option>
                        </el-select>
                        <img
                          slot="append"
                          class="after"
                          @click.stop="advancedQuery.splice(index, 1)"
                          src="/static/icon/delete.png"
                          style="width: 16px"
                        />
                      </el-input>
                    </template>
                    <template v-if="newParam.searchType === '2'">
                      <el-input
                        v-for="(item, index) in neardQuery"
                        :key="index + 'ne'"
                        placeholder="請輸入内容"
                        @click.stop.native
                        @keyup.enter.native="clickSearch(true)"
                        v-model="item.keyword"
                        class="input-select input-select-label"
                        style="margin-bottom: 0.5rem"
                      >
                        <div slot="prepend">
                          NEAR字距
                          <el-select
                            v-model="item.type"
                            v-if="item.type"
                            style="width: 80px"
                            slot="prepend"
                            placeholder="請選擇"
                          >
                            <el-option label="OR" value="or"></el-option>
                            <el-option label="AND" value="and"></el-option>
                            <el-option label="NOT" value="not"></el-option>
                          </el-select>
                          <el-input-number
                            v-model="item.spacing"
                            style="width: 80px; text-align: right"
                            :min="1"
                            :max="30"
                            controls-position="right"
                          >
                          </el-input-number>
                        </div>
                      </el-input>
                    </template>

                    <div class="content">
                      <div class="justify-between align-center">
                        <template v-if="newParam.searchType === '0'">
                          <el-button size="small" @click.stop="clearsearch"
                            >清除關鍵詞
                            <i class="iconfont icon-delete"></i>
                            ></el-button
                          >
                        </template>

                        <template v-if="newParam.searchType === '1'">
                          <!-- <el-button
                  size="small"
                  @click.stop="
                    advancedQuery.push({
                      type: 'and',
                      keyword: '',
                    })
                  "
                  >增加條件 <i class="el-icon-plus"></i
                ></el-button> -->
                          <el-button
                            size="small"
                            @click.stop="clearsearch"
                            style="margin-right: 15px"
                            >清除所有關鍵詞
                            <!-- <i class="el-icon-delete"></i> -->
                            <i class="iconfont icon-delete"></i>
                          </el-button>
                          <!-- @click="
                    isSearching = false;

                    advancedQuery = [];
                    search.keyword = '';
                  " -->
                        </template>
                        <template v-if="newParam.searchType === '2'">
                          <el-button
                            size="small"
                            @click.stop="clearsearch"
                            style="margin-right: 15px"
                            >清除條件
                            <!-- <i class="el-icon-delete"></i -->
                            <i class="iconfont icon-delete"></i>
                          </el-button>
                        </template>
                        <el-checkbox v-model="searchAccuracyType"
                          >漢字關聯</el-checkbox
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- :class="(index ==searchInBook.length-1)? (sltOpearListId > item.passageXmlId) &&  'active' : (sltOpearListId > item.passageXmlId) &&sltOpearListId < searchInBook[index+1].passageXmlId && 'active' " -->
              <el-collapse class="list-box" value="1">
                <el-collapse-item
                  :title="`共${searchInBook.length}項`"
                  name="1"
                >
                  <ul class="old-list">
                    <li
                      v-for="(item, index) in searchInBook"
                      :key="item.id + '-' + index"
                      :id="'r1--' + sltOpearListId"
                      :class="
                        searchIndex != -1
                          ? sltOpearListId == item.xmlId
                            ? 'active'
                            : ''
                          : index == searchInBook.length - 1
                          ? sltOpearListId > item.passageXmlId && 'active'
                          : sltOpearListId > item.passageXmlId &&
                            sltOpearListId <
                              searchInBook[index + 1].passageXmlId &&
                            'active'
                      "
                      @click="gotoPage(item, index)"
                    >
                      <!-- @click="viewDetail(item, item.bookId, item.id, index)"//书外跳转 -->
                      <span class="sort">{{ index + 1 }}.</span>
                      <div class="list-content">
                        <i
                          class="el-icon-info"
                          style="color: rgb(204, 51, 51)"
                          v-if="item.hitType == 2"
                        />
                        <span v-html="item.text"></span>
                        <p
                          style="font-size: 14px; color: #ccc"
                          v-html="item.juanName"
                        ></p>
                      </div>
                    </li>
                  </ul>
                </el-collapse-item>
              </el-collapse>
            </template>
            <template v-if="opeatMenuSltType == 2">
              <div class="note-ipt-box newborder">
                <span>{{
                  noteContent.noteTarget && noteContent.noteTarget.length > 60
                    ? noteContent.noteTarget.substring(0, 60) + "......"
                    : noteContent.noteTarget
                }}</span>
                <el-input
                  type="textarea"
                  :rows="8"
                  :placeholder="
                    noteContent.noteTarget
                      ? '請輸入内容'
                      : '請先在正文中選定字段'
                  "
                  v-model="noteContent.noteContent"
                >
                </el-input>
                <img
                  src="/static/icon/note-edite.png"
                  class="note-ipt-icon"
                  @click="addBookNoteData"
                />
              </div>

              <el-collapse class="list-box" value="1">
                <el-collapse-item :title="`共${myBookNote.length}項`" name="1">
                  <ul class="old-list">
                    <li
                      v-for="(item, index) in myBookNote"
                      :key="item.createTime"
                      :class="sltOpearListId == item.noteId && 'active'"
                      @click="
                        sltOpearListId = item.noteId;
                        noteContent = JSON.parse(JSON.stringify(item));
                        findNoteInBook(item);
                      "
                    >
                      <span class="sort">{{ myBookNote.length - index }}.</span>
                      <div class="list-content">
                        {{ item.noteContent }}
                        <div class="justify-end">
                          <img
                            class="icon"
                            src="/static/icon/delete.png"
                            @click.stop="delBookNote(item.noteId)"
                          />
                        </div>
                      </div>
                    </li>
                  </ul>
                </el-collapse-item>
              </el-collapse>
            </template>
            <template v-if="opeatMenuSltType == 5">
              <span> 書簽</span>
              <el-collapse class="list-box" value="1">
                <el-collapse-item :title="`共${myBookMark.length}項`" name="1">
                  <ul class="old-list">
                    <li
                      v-for="(item, index) in myBookMark"
                      :key="item.noteId"
                      :class="sltOpearListId == item.noteId && 'active'"
                      @click="
                        sltOpearListId = item.noteId;
                        findNoteInBook(item, 2);
                      "
                    >
                      <span class="sort">{{ myBookMark.length - index }}.</span>
                      <div class="list-content">
                        {{ item.noteTarget }}
                        <div class="justify-end">
                          <img
                            class="icon"
                            src="/static/icon/delete.png"
                            @click.stop="delBookNote(item.noteId, 2)"
                          />
                        </div>
                      </div>
                    </li>
                  </ul>
                </el-collapse-item>
              </el-collapse>
            </template>
            <template v-if="opeatMenuSltType == 3">
              <div class="note-ipt-box newborder">
                <span>{{
                  qaContent.contentName && qaContent.contentName.length > 60
                    ? qaContent.contentName.substring(0, 60) + "......"
                    : qaContent.contentName
                }}</span>
                <el-input
                  type="textarea"
                  :rows="8"
                  :placeholder="
                    qaContent.contentName
                      ? '請輸入内容'
                      : '請先在正文中選定字段'
                  "
                  v-model="qaContent.feedbackInfo"
                  suffix-icon="el-icon-date"
                >
                </el-input>
                <img
                  src="/static/icon/note-edite.png"
                  class="note-ipt-icon"
                  @click="addBookQa"
                />
              </div>

              <el-collapse class="list-box" value="1">
                <el-collapse-item :title="`共${myBookQa.length}項`" name="1">
                  <ul class="old-list">
                    <li
                      v-for="(item, index) in myBookQa"
                      :key="item.createTime"
                      :class="sltOpearListId == item.feedbackId && 'active'"
                      @click="
                        sltOpearListId = item.feedbackId;
                        qaContent = JSON.parse(JSON.stringify(item));
                        findNoteInBook(item);
                      "
                    >
                      <span class="sort">{{ index + 1 }}.</span>
                      <div class="list-content">
                        {{ item.feedbackInfo }}
                        <div class="justify-end">
                          <img
                            class="icon"
                            src="/static/icon/delete.png"
                            @click.stop="deleteBookQaData(item.feedbackId)"
                          />
                        </div>
                      </div>
                    </li>
                  </ul>
                </el-collapse-item>
              </el-collapse>
            </template>
            <template v-if="opeatMenuSltType == 4">
              <span>
                當前頁字數： {{ totalWordNumber }}
                <p v-html="statisticsFonts"></p>
              </span>
            </template>
          </div>
        </el-card>
      </div>
    </div>
    <el-card
      id="popListBox"
      v-show="menuListPositon"
      class="menu-pop-list"
      :style="
        menuListPositon && {
          left: menuListPositon.x + 'px',
          top: menuListPositon.y + 'px',
        }
      "
    >
      <div
        v-for="(item, index) in menuList"
        @click.stop="selectMenuType($event, item, index)"
        :key="item.text"
      >
        <img :src="'/static/icon/' + item.icon" />
        {{ item.text }}
      </div>
    </el-card>
    <!-- <BuyConfirm :buyVisible="buyVisible"></BuyConfirm> -->
  </div>
</template>

<script>
// 全局说明
// 开发过程很多需求一边确认一边开发，为减少耦合，代码没有抽象，若不重构后期维护人员谨慎合并代码
import xmlTree from "./xmlTree"
import footNote from "./footNote"
import booksTree from "../components/bookstree.vue"
import { getDAesString } from "@/utils/encryp"
import BuyConfirm from "@/components/buyconfirm.vue"
import eventBus from "@/utils/eventBus.js"
// import searchTab from "@/components/searchTab.vue"
import {
  getBookContent,
  getBookContentInSearch,
  getBookCatalogue,
  addBookNote,
  editBookNote,
  addBookQa,
  getBookQaList,
  deleteBookQaList,
  getNoteListNew,
  deletBookNote,
  addRead,
  essearch,
  // getSearchDetail,
  getBookDetail,
  addLatest,
  getQaDetail,
  getNoteDetail
  // getPdfImages
} from "@/api/api"
// document.oncopy = function () { return false }
const colors = {
  0: {
    name: "默認",
    b: "#fff",
    f: "#000",
  },
  1: {
    name: "緑色",
    b: "#C7EDCC",
    f: "#000",
  },

  2: {
    name: "黄色",
    b: "#FAF9DE",
    f: "#000",
  },
  3: {
    name: "灰色",
    b: "#EAEAEF",
    f: "#000",
  },
}

export default {
  name: "WordTest",
  components: { xmlTree, booksTree, footNote, BuyConfirm },
  data () {
    return {
      // buyVisible: false,
      volume: '',
      changefontSize: 0,
      newParam: {
        keyword: "",
        searchType: "0",
        bookIds: "",
        advaList: [],
        isInnerSearch: 1,//0 全局 1书内检索
        searchAccuracyType: 1,//精确or模糊搜索 0 精确 1模糊
      },
      searchAccuracyType: true,//精确or模糊搜索 0 精确 1模糊
      advancedQuery: [
        {
          type: "and",
          keyword: "",
        },
        {
          type: "and",
          keyword: "",
        },
      ],
      neardQuery: [
        {
          spacing: 5,
          keyword: "",
        },
        {
          spacing: 5,
          type: "and",
          keyword: "",
        },
      ],


      isQuanKu: false,//是否全庫目錄
      catalogIdList: [], //结果id
      // pdfList: [],
      bookParam: {
        bookId: 26,
        startPage: 1,
        catalogId: 0,
      },
      bookName: "",
      bookPath: "",//图片目录
      keyword: "", // s书内搜索关键字
      keywordStr: "",//前端高亮
      noteOrQa: {},//笔记问题反馈高亮
      index: 0,
      themeId: "0",
      nodeList: [],
      allData: [],
      isVertical: false,
      isSelectColor: false,
      fontSize: 0,
      colors,
      selectTreeIndex: false,

      defaultProps: {
        children: "children",
        label: "catalogName",
        isLeaf: "level"
      },
      qaContent: {
        feedbackPage: "",
        feedbackInfo: "",
      },
      myBookQa: [],
      underline: {},
      menuList: [
        // {
        //   icon: "copy.png",
        //   text: "文本複製",
        //   onClick: (item) => {
        //     document.oncopy=true;
        //     if (!this.selectionData || !this.selectionData.text) {
        //       return;
        //     }
        //     this.copyText(this.selectionData.text.substring(0, 200), this);
        //     document.oncopy = function(){ return false; };
        //   },
        // },
        // this.bookdetail.publishTime ? `${this.selectionData.text.substring(0, 100)}出自：${this.catalogueList[this.bookParam.juanNum - 1].catalogName}。${this.writer}，${this.bookdetail.copier}校點：${this.bookdetail.newName}，北京：${this.bookdetail.publisher ? this.bookdetail.publisher : '北京大學'}，出版時間：${this.bookdetail.publishTime}，第${data.page}頁。` : `${this.selectionData.text.substring(0, 100)}出自：${this.catalogueList[this.bookParam.juanNum - 1].catalogName}。${this.writer}，${this.bookdetail.copier}校點：${this.bookdetail.newName}，北京：${this.bookdetail.publisher ? this.bookdetail.publisher : '北京大學'}，第${data.page}頁。`,

        {
          icon: "source.png",
          text: "引用(限一百字)",
          onClick: () => {
            if (!this.selectionData || !this.selectionData.text) {
              return
            }
            document.oncopy = true
            this.underline = { text: this.selectionData.text, xmlId: this.selectionData.data.id }
            const { data = {} } = this.selectionData
            this.copyText(
              `${this.selectionData.text.substring(0, 100)}出自：${this.catalogueList[this.bookParam.juanNum - 1].catalogName}。${this.writer}，${this.bookdetail.copier}：${this.volume}，北京：${this.bookdetail.publisher ? this.bookdetail.publisher : '北京大學'}${this.bookdetail.publishTime ? '，' + this.bookdetail.publishTime : ''}，第${data.page}頁。`,
              this
            )
            // ，${this.bookdetail.publishTime}
            //  +
            //   this.catalogueList[this.bookParam.juanNum - 1].catalogName +
            //   ","
            document.oncopy = function () { return false }
          },
        },
        {
          icon: "copy-link.png",
          text: "複製網址",
          onClick: () => {
            this.underline = { text: this.selectionData.text, xmlId: this.selectionData.data.id }
            document.oncopy = true
            let copyhref = window.location.host
            copyhref += `/#/viewer?bookId=${this.bookParam.bookId}&bookName=${this.bookParam.bookName}&juanNum=${this.bookParam.juanNum}&startPage=${this.bookParam.startPage}&beginPage=${this.bookParam.beginPage}&endPage=${this.bookParam.endPage}&catalogId=${this.bookParam.catalogId}&clickCatalogId=${this.bookParam.catalogId}&formSearchNotJump=${this.bookParam.formSearchNotJump}&underline=${JSON.stringify(this.underline)}`
            this.copyText(copyhref, this)
            document.oncopy = function () { return false }
          },
        },
        {
          icon: "book-in-search.png",
          text: "書内檢索",
          onClick: () => {
            let ret = this.JansuoXianzhi(this.selectionData.text)
            if (!ret) return false
            this.opeatMenuSltType = 1
            this.bookParam.keyword = this.selectionData.text
            this.newParam.keyword = this.selectionData.text
            // this.searchDataInBook()
            this.viewDetail()

          },
        },
        {
          icon: "all-search.png",
          text: "全庫檢索",
          onClick:
            () => {
              let ret = this.JansuoXianzhi(this.selectionData.text)
              if (!ret) return false
              window.open("/#/search?keyword=" + this.selectionData.text, '_blank')
              // const newhre = this.$router.resolve({
              //   name: "Search",
              //   params: {
              //     keyword: this.selectionData.text
              //   }
              // })
              // window.open(newhre.href, '_blank')

            },
          index: 1,
        },
        {
          icon: "sign.png",
          text: "添加筆記",
          onClick: () => {
            this.noteOrQa = { noteOrQa: this.selectionData.text, type: 1 }
            this.noteContent = {
              noteTarget: this.selectionData.text,
              // noteContent: this.selectionData.text,
            }
            // console.log(this.noteContent);
            eventBus.$emit("addLatestNew", 2, 'note') //写入操作记录
          },
          index: 2,
          id: "his_note_dia"
        },
        {
          icon: "mark.png",
          text: "添加書簽",
          onClick: () => {
            // this.noteOrQa = this.selectionData.text
            this.addBookMark()
            eventBus.$emit("addLatestNew", 2, 'mark') //写入操作记录
          },
          index: 5,
          id: "his_mark_dia"
        },
        {
          icon: "feedback.png",
          text: "問題反饋",
          onClick: () => {
            this.noteOrQa = { noteOrQa: this.selectionData.text, type: 1 }
            this.qaContent = {
              // feedbackInfo: this.selectionData.text,
              // noteContent: this.selectionData.text,
              contentName: this.selectionData.text,
            }
            eventBus.$emit("addLatestNew", 2, 'feedback') //写入操作记录
          },
          index: 3
        },
        {
          icon: "counter.png",
          text: "字數統計",
          onClick: () => {
            this.opeatMenuSltType = 4
            if (this.selectionData.text) {
              this.statisticsFonts =
                "<p>選中文字字數： " +
                this.selectionData.text.length +
                "</p><p>選中標點符號字數：" +
                this.countPunctuation(this.selectionData.text) +
                "</p>"
            }
            // this.$alert("当前选中字数为：" + this.selectionData.text.length);
            eventBus.$emit("addLatestNew", 2, 'word-count') //写入操作记录
          },
          index: 4
        },
      ],
      isOperaText: true,

      opeatMenuSltType: 0,
      opearMenuList: [
        {
          icon: "notes.png",
          activeIcon: "notes-active.png",
          text: "校記",
          key: 0,
          id: "his_jiaoji"
        },
        {
          icon: "bg-book.png",
          activeIcon: "bg-book-active.png",
          text: "書内檢索",
          key: 1
        },
        {
          icon: "add-sign.png",
          activeIcon: "add-sign-active.png",
          text: "添加筆記",
          key: 2,
          id: "his_note"
        },
        // {
        //   icon: "couter-bg.png",
        //   activeIcon: "tongji.png",

        //   text: "统计",
        // },
        {
          icon: "shuqian.png",
          activeIcon: "shuqian-active.png",
          text: "書簽列表",
          key: 5,
          id: "his_mark"
        },
        {
          icon: "feedback-bg.png",
          activeIcon: "feadback-active.png",
          text: "問題反饋",
          key: 3,
          id: "his_feedback"
        },

        {
          icon: "text-counter.png",
          activeIcon: "text-counter-active.png",
          text: "字數統計",
          key: 4,
          id: "his_wordcount"
        },
      ],
      notesText: "",

      selectionData: {}, // 选中的数据信息
      menuListPositon: null,
      footNoteIndex: 0,
      footNoteList: [],

      catalogueList: [], // 章节列表

      // 新增笔记
      noteContent: {
        noteTarget: "",
        noteContent: "",
        noteType: 1,
      },
      myBookNote: [],
      myBookMark: [],//書簽
      myBookMarkMap: [],//本卷书签 用于高亮
      selectNoteData: {},
      totalWordNumber: 0,
      searchInBook: [],
      rightOpera: {},
      isLeftTree: true,
      sltOpearListId: "", //搜索高亮id
      xiaoOpearListId: "", //校记高亮id 右侧
      contentBoxSize: {},
      sltCatalogId: "", //高亮子菜单的id
      secondTitle: "", //  顶部二级菜单
      writer: "", //作者
      parentNodes: [],
      statisticsFonts: "", //字数统计

      passageXmlId: 0, //高亮范围
      searchIndex: -1, //搜素列表index
      bookdetail: {},//书详情
      rightCatalogId: "", //右侧校对等点击获取
    }
  },
  beforeRouteEnter (to, from, next) {
    let { juanNum, bookId, beginPage, startPage, endPage } = to.query
    getBookContent({
      juanNum,
      bookId,
      startPage: beginPage || startPage,
      endPage,
    }).then((d) => {
      if (d.code == 200) {
        next()
      }
    })
  },
  computed: {
    // noteOrQa () {
    // console.log(this.selectNoteData, 'this.selectNoteData')
    // let ret = (this.opeatMenuSltType == 2 || this.opeatMenuSltType == 3) && this.selectNoteData.noteTarget ? this.selectNoteData.noteTarget : ''
    // let ret = (this.opeatMenuSltType == 2) &&
    //   this.selectNoteData.noteTarget
    //   ? this.selectNoteData.noteTarget
    //   : this.opeatMenuSltType == 3 && this.selectNoteData.contentName
    //     ? this.selectNoteData.contentName
    //     : ''
    // this.selectNoteData = {}
    // return ret
    // },
    // shuqian () {
    //   let ret = ((this.opeatMenuSltType == 5) &&
    //     this.selectNoteData.noteTarget) ? this.selectNoteData.noteTarget : ''
    //   this.selectNoteData = {}
    //   return ret
    // }

  },
  created () {
    this.$nextTick(() => {
      // document.oncontextmenu = new Function("event.returnValue=false")
      // 禁用选择
      // document.onselectstart = new Function("event.returnValue=false")
      document.oncopy = new Function("event.returnValue=false")
      // document.onpaste = new Function("event.returnValue=false")
      // document.addEventListener("keydown", function (e) {
      //   if (e.key == "F12") {
      //     e.preventDefault() // 如果按下键F12,阻止事件
      //   }
      // })
    })
  },
  mounted () {

    let query = this.$route.query
    // console.log(query, 'query')
    //操作列表跳转参数
    if (query.operStr) {
      // console.log(query.operStr, 'query.operStr')
      let operStr = JSON.parse(query.operStr)
      const { searchType, advancedQuery, nearQuery, keyword, bookId } = operStr
      if (searchType) {
        this.newParam.searchType = searchType
      }
      if (advancedQuery) {
        this.advancedQuery = advancedQuery
      }
      if (nearQuery) {
        this.nearQuery = nearQuery
      }

      this.newParam.keyword = keyword
      this.bookParam.bookId = bookId
      if (query.keyword) {
        this.opeatMenuSltType = 1
        this.searchDataInBook()
      }
    }

    if (query.advancedQuery) this.advancedQuery = JSON.parse(query.advancedQuery)
    if (query.neardQuery) this.neardQuery = JSON.parse(query.neardQuery)
    if (query.searchType) this.newParam.searchType = query.searchType
    if (query.underline) this.underline = JSON.parse(query.underline)
    this.passageXmlId = query.passageXmlId
    // if (query.advaList) query.advaList = JSON.parse(query.advaList);
    // this.writer =query.writer || this.$route.params.writer || "作者：~";
    query.juanNum = query.juanNum ? query.juanNum : 1
    // query.catalogId = query.catalogId ? query.catalogId : ''
    // query.bookId = query.bookId || 26
    this.bookParam = query
    this.bookName = query.bookName
    if (query.pageId) {
      this.sltOpearListId = "1--" + query.pageId
      this.xiaoOpearListId = query.pageId
    }

    this.getBookMenu()
    this.getBookNoteData()
    this.getBookNoteData(2)
    this.getBookQaData()
    this.getDetail() //获取书详情
    // this.filtMyBookMark()

    if (query.source == "uc" || query.source == "note") { //个人中心笔记跳转
      this.opeatMenuSltType = 2
      // this.sltOpearListId = this.bookParam.noteId
      // if(this.sltOpearListId.length === 'und') this.sltOpearListId = query.sltNoteData && query.sltNoteData.noteId;
    } else if (query.source == "qa") {
      this.opeatMenuSltType = 3
      // this.sltOpearListId = this.bookParam.feedbackId
    } else if (this.bookParam.hitType == "2") {//跳转到校记或搜索
      this.opeatMenuSltType = 0
      this.jumpSearchShow(query)
    } else if (this.bookParam.hitType == "1") {
      this.opeatMenuSltType = 1
      this.jumpSearchShow(query)
    }

    // window.addEventListener('click',
    //正文点击脚注，右侧脚注滚动到相应位置
    this.$root.$on("clickNote", (id) => {
      this.opeatMenuSltType = 0
      this.isOperaText = true
      this.xiaoOpearListId = id

      setTimeout(() => {
        window["x" + id] &&
          window["x" + id].scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "nearest",
          })
      }, 1000 / 60)
    })
    this.$root.$on("imgload", () => {
      const page = this.bookParam.xmlId
      if (window["page" + page]) {
        window["page" + page].scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest",
        })
      }
    })

    this.getContentBoxWidth()

    // 写本地读书记录
    let recently = window.localStorage.recentlyList
    recently = recently ? JSON.parse(recently) : []
    delete this.bookParam.children
    recently.unshift(this.bookParam)
    recently = recently.slice(0, 50)
    window.localStorage.recentlyList = JSON.stringify(recently)

    //书内点击书签删除
    const _this = this
    window.delshuqian = function (id) {
      _this.delBookNote(id, 2)
    }

  },
  beforeDestroy () {
    document.removeEventListener("mouseup", this.clearmenuListPositon, false)
  },
  watch: {
    // "bookParam.catalogId": {
    "bookParam.catalogId": {
      handler (d) {
        // console.log(d, 'xxxx')
        // this.noteContent = {}
        // this.qaContent = {}
        // this.sltOpearListId = ''
        // this.noteOrQa = ''
        // this.shuqian = ''
        // console.log(d, 'dxdf')
        const list = this.$refs.leftCatalogList
        list.setCurrentKey(d)
        this.expandedTree(list.store.nodesMap[d])
        // console.log(d, 'dsfst111')
        // this.$nextTick(() => {
        //   window["tree" + d] &&
        //     window["tree" + d].scrollIntoView({
        //       behavior: "smooth",
        //       block: "center",
        //       inline: "nearest",
        //     })

        // })

      },
      deep: true
    },
    "bookParam.juanNum": {
      handler (d) {
        if (this.bookParam.juanNum) {
          // console.log(this.bookParam.juanNum, 'watch')
          this.filtMyBookMark()
        }

      },
      deep: true
    },

    // immediate: true
    // },
    "opeatMenuSltType": function (d) {
      // this.noteContent = {}
      // this.qaContent = {}
      this.sltOpearListId = ''
      // console.log(this.opeatMenuSltType, query.source, 'sltOpearListId')

      // this.noteOrQa = ''
      // this.shuqian = ''
    },
    //  "myBookMark": function (d) {
    //   this.sltOpearListId = this.myBookMark.length > 0 ? this.myBookMark[0].noteId : ''
    // },
    // "myBookNote": function (d) {
    //   this.sltOpearListId = this.myBookNote.length > 0 ? this.myBookNote[0].noteId : ''
    // },
    // "myBookQa": function (d) {
    //   this.sltOpearListId = this.myBookQa.length > 0 ? this.myBookQa[this.myBookQa.length - 1].feedbackId : ''
    // }

  },

  methods: {
    // 获取本章节书签
    filtMyBookMark () {


      // console.log("markfilt")
      let tempBookMark = this.myBookMark.filter(item => item.juanNum == this.bookParam.juanNum)
      this.myBookMarkMap = []
      tempBookMark.forEach((item) => {
        let str = 'sq' + item.xmlId
        if (!this.myBookMarkMap[str]) { this.myBookMarkMap[str] = [] }
        this.myBookMarkMap[str].push({ noteTarget: item.noteTarget, noteId: item.noteId, type: 2 })

      })

      // console.log(this.myBookMarkMap, 'this.myBookMarkMap')
    },
    cunmutopath () {
      const { bookId, catalogId, juanNum } = this.bookdetail.bookLinkVo
      this.$router.push({
        path: '/viewer', query: {
          bookId,
          catalogId,
          juanNum
        }
      })
      this.$router.go(0)

    },
    nextbook (type) {
      console.log(type)
      this.$bus.$emit("nextBook", { type, bookId: this.bookParam.bookId })
    },
    gotoBookDetail () {
      const url = this.$router.resolve("/bookDetail?id=" + this.bookParam.bookId)
      window.open(url.href)
    },
    changeTreeIndex () {
      this.selectTreeIndex = !this.selectTreeIndex
      // this.$refs.leftCatalogList.default-expand-all = this.selectTreeIndex;
      // 折叠所有节点
      if (!this.selectTreeIndex) {
        for (var i = 0; i < this.$refs.leftCatalogList.store._getAllNodes().length; i++) {
          this.$refs.leftCatalogList.store._getAllNodes()[i].expanded = false
        }
      }
      // 展开所有节点
      if (this.selectTreeIndex) {
        for (var i = 0; i < this.$refs.leftCatalogList.store._getAllNodes().length; i++) {
          this.$refs.leftCatalogList.store._getAllNodes()[i].expanded = true
        }
      }
    },
    changeVertical () {
      this.isVertical = !this.isVertical
      this.$refs.opearBox.style = ''
      this.$refs.leftDragCate.style = ''
      this.getContentBoxWidth()
      // let paraxmlid = this.bookParam.xmlId;
      // this.gotoSignDetail(paraxmlid);

      //左侧和内容展示区默认展示
      this.isOperaText = true
      this.isLeftTree = true

      //新增,正文内容定位

      this.leftCatelogIdJunpRight(this.sltCatalogId)
      this.gotoSearchDetail()
    },
    getDetail () {
      getBookDetail(this.bookParam.bookId).then((e) => {
        if (e.code == 200) {

          this.bookdetail = e.data
          // "學統（ 非凡哥）（   精第一六〇下册）" 取出學統加书名号 去掉非凡哥
          let chuli = this.bookdetail.bookName
          let newName = ""
          let names = chuli.split('（')
          if (names.length == 1) {
            newName = this.bookdetail.bookName
          } else if (names.length == 2) {
            newName = `《${names[0]}》（${names[1]}`
            names.splice(0, 2)
            newName += names.join()
          } else if (names.length > 2) {
            newName = `《${names[0]}》（${names[2]}`
            names.splice(0, 3)
            newName += names.join()
          }
          this.bookdetail.newName = newName
          let pubtime = this.bookdetail.publishTime
          this.bookdetail.publishTime = (pubtime && pubtime != 'null') ? `${new Date(pubtime).getFullYear()}年${new Date(pubtime).getMonth() + 1}月` : ''
          this.writer = e.data && e.data.writer
          this.bookPath = e.data && e.data.bookPath

          // 作者拼接
          let writerarr = this.bookdetail.writerList.reduce(function (r, a) {
            r[a.writerRole] = r[a.writerRole] || []
            r[a.writerRole].push(a)
            return r
          }, Object.create(null))
          var writernew = ''
          let roleindex = 0
          for (let rolekey in writerarr) {
            if (roleindex != 0) writernew += '，'
            writerarr[rolekey].forEach((iitem, iindex) => {
              if (iindex != 0) writernew += '、'
              writernew += `[${iitem.writerDynastyName}]${iitem.writerName}`
              if (iindex + 1 == writerarr[rolekey].length) writernew += rolekey
            })
            roleindex++
          }
          this.writer = writernew
          //校点者拼接
          let copier = ''
          this.bookdetail.copierList && this.bookdetail.copierList.forEach((item, index) => {
            if (index != 0) copier += '、'
            copier += item.copierName
          })
          copier += '校點'
          this.bookdetail.copier = copier
          // console.log(this.bookdetail, 'this.bookdetail')
          // console.log(e, 'detail')
          // if (e.data) {
          //   getPdfImages(e.data.bookPath).then((e) => {
          //     this.pdfList = e.data.map(item => {
          //       return this.baseImgPath + 'pdf/' + this.bookPath + '/' + item
          //     })

          //   })
          // }
        } else {
          this.$message.error(e.msg)
        }
      })
    },
    expandedTree (checkedNode) {
      if (!checkedNode) {
        return
      }
      checkedNode.expanded = true
      if (checkedNode.parent) {
        this.expandedTree(checkedNode.parent)
      }
    },
    jumpSearchShow (query) {
      if (query.keyword) {
        this.keyword = query.keyword
        this.searchDataInBook()
      }
    },
    topSearch () {
      this.opeatMenuSltType = 1
      this.searchDataInBook()
    },
    // 统计标点符号
    countPunctuation (str) {
      const punct = "!,;.-?《》（）〔〕「」：。，；-？！‘’”“`、/—"
      let count = 0
      for (let i = 0; i < str.length; i++) {
        if (!punct.includes(str[i])) {
          continue
        }
        count++
      }
      return count
    },
    // 最近操作
    addLatest (type) {
      let tempoper = {}
      if (type == 1) {
        const {
          bookId,
          readPage,
          // juanName,
          catalogName,
          beginPage,
          endPage,
          juanNum,
          catalogId,
        } = this.bookParam

        tempoper = {
          bookId,
          readPage,
          // juanName,
          catalogName: catalogName || this.catalogueList[juanNum - 1].catalogName || '',
          beginPage,
          endPage,
          juanNum,
          catalogId,
        }
      } else {
        const { keyword, advaList, searchType, isInnerSearch, searchAccuracyType } = this.newParam
        tempoper = {
          keyword, advaList, searchType, isInnerSearch, bookId: this.bookParam.bookId, searchAccuracyType
        }
        if (this.newParam.searchType == 1) {
          tempoper.advancedQuery = this.advancedQuery
        }
        if (this.newParam.searchType == 2) {
          tempoper.nearQuery = this.nearQuery
        }
      }
      let param = {
        guestId: this.$getUUID(),
        operType: type == 1 ? "read" : "search-in",
        operStr: JSON.stringify(tempoper)
      }
      // console.log(param, 'param')
      addLatest(
        param
      ).then((e) => {
        // console.log(e)
      })
    },
    addReadHistory () {
      // console.log(this.sltCatalogId, this.bookParam.catalogId)
      const {
        bookId,
        readPage,
        // juanName,
        catalogName,
        beginPage,
        endPage,
        juanNum,
        catalogId,
      } = this.bookParam
      // console.log(this.bookParam);
      addRead({
        bookId,
        readPage: this.bookParam.catalogId,
        // juanName,
        beginPage,
        endPage,
        juanNum,
        catalogId,
        juanName: catalogName,
      }).then((e) => {
        // console.log(e)
      })
    },
    // 竖立展示时，捕捉滚动事件
    getContentBoxWheel (e) {
      if (this.isVertical) {
        e.stopPropagation()
        e.preventDefault()
        window.bookContentBox.scrollLeft += e.wheelDeltaY
      }
    },
    // 滚动区域 获取第一个可是区域的目录ID
    getViewInCatelogInfo () {
      clearTimeout(this.scrollTimer)
      this.scrollTimer = setTimeout(() => {
        if (this.rightCatalogId) { //右侧脚注等点击获取二级标题
          this.bookParam.catalogId = this.rightCatalogId
          // console.log(this.rightCatalogId, 'this.rightCatalogId')
          this.sltCatalogId = this.rightCatalogId
          this.getTitleNew(this.catalogueList, this.rightCatalogId)

        }
        else { //滚动在正文获取二级标题，左侧id
          // console.log("gund")
          const allCatelogTitle = document.querySelectorAll("[id^=catalogId]")

          const { width, height } = this.contentBoxSize
          let isTitle = null
          for (let i = 0; i < allCatelogTitle.length; i++) {
            if (isTitle) {
              break
            }
            let pos = allCatelogTitle[i].getBoundingClientRect()
            if (
              pos.top > 74 &&
              pos.top < height &&
              pos.left > 64 &&
              pos.left < width + 160
            ) {

              let id = allCatelogTitle[i].dataset.id
              if (id == this.sltCatalogId) {
                return
              }
              this.sltCatalogId = id
              let getTitle = (data, isGetTitle = false) => {
                data.forEach((val) => {
                  if (val.catalogId != this.sltCatalogId) {
                    val.children.length && getTitle(val.children, true)
                  } else {
                    this.bookParam.catalogId = val.catalogId
                    this.secondTitle = isGetTitle ? val.catalogName : ''
                    // this.secondTitle = val.catalogName;
                    isTitle = val.catalogName
                    // this.$refs.leftCatalogList.setCurrentKey(val.catalogId)
                    // this.$refs.leftCatalogList.store.nodesMap[
                    //   val.catalogId
                    // ].parent.expanded = true
                  }
                })
              }

              getTitle(this.catalogueList)
              break
            }
          }

        }
      }, 1000 / 30)
    },
    // 根据catalogId获取标题
    getTitleNew (data, cId) {

      data.forEach((val) => {
        if (val.catalogId != cId) {
          val.children.length && this.getTitleNew(val.children, cId)
        } else {
          this.secondTitle = (val.level > 1) ? val.catalogName : ''
          this.rightCatalogId = ''
          return
        }
      })
    },
    // 获取内容去宽高信息
    getContentBoxWidth () {
      this.contentBoxSize = {
        width: window.bookContentBox.clientWidth * 0.85,
        // width: window.bookContentBox.clientWidth - 64,
        height: window.bookContentBox.clientHeight - 64,
      }
      this.$root.$emit("contentBoxSize", this.contentBoxSize)
      // 窗口或者所在box变化时（见下）获得boxWidth
      window.addEventListener("resize", (e) => {
        clearTimeout(this.resizeTimer)
        this.resizeTimer = setTimeout(() => {
          this.contentBoxSize = {
            // width: window.bookContentBox.clientWidth - 64,
            width: window.bookContentBox.clientWidth * 0.85,
            height: window.bookContentBox.clientHeight - 64,
          }
          this.$root.$emit("contentBoxSize", this.contentBoxSize)
        }, 500)
      })
    },
    // searchDataInBook () {
    //   if (!this.keyword) {
    //     return this.$message.warning("請輸入關鍵字")
    //   }
    //   // console.log(this.bookParam,'nnn');
    //   // this.opeatMenuSltType = 1;
    //   // console.log(this.$route.query,'aaa');
    //   // if(this.bookParam.hitType == '2') this.opeatMenuSltType = 0;
    //   // 云~$花蕋~!书   ~代表关键字的分隔符，$意思是条件or， !意思是条件not, 关键字前面没有 $和!代表 and
    //   // let keywordarr = this.keyword.split("~");
    //   // let advaList = [];
    //   // for (let i = 0; i < keywordarr.length; i++) {
    //   //   let item = keywordarr[i];
    //   //   if (i == 0) continue;
    //   //   if (item.indexOf("$") > -1) {
    //   //     let nitem = item.slice(1);
    //   //     advaList.push({ type: "or", keyword: nitem });
    //   //   } else if (item.indexOf("!") > -1) {
    //   //     let nitem = item.slice(1);
    //   //     advaList.push({ type: "not", keyword: nitem });
    //   //   } else {
    //   //     advaList.push({ type: "and", keyword: item });
    //   //   }
    //   // }
    //   // console.log(advaList, "nnn");
    //   essearch({
    //     // advaList: advaList,
    //     bookIds: this.bookParam.bookId,
    //     // searchType: this.bookParam.searchType,
    //     // keyword: keywordarr[0],
    //     keyword: this.keyword,
    //     isInnerSearch: 1
    //   }).then((data) => {
    //     if (data.code == 200) {
    //       this.catalogIdList = data.data.catalogIdList
    //       let page = []

    //       data.data.bookList.forEach((item) => {
    //         item.bookJuanList.forEach((val) => {
    //           val.bookPageList.forEach((v) => {
    //             v.juanName = val.juanName
    //             page.push(v)
    //           })

    //         })
    //       })
    //       // page = [...page, ...val.bookPageList]
    //       // console.log(page, 'page')
    //       this.searchInBook = page
    //       this.searchInBook.forEach((item, index) => {
    //         this.$set(item, 'xmlId', 0)
    //       })
    //       // console.log(this.searchInBook,345);
    //       // console.log(this.sltOpearListId,678);
    //       //this.$root.$emit("clickNote",this.sltOpearListId);
    //     }
    //   })
    // },
    clearsearch () {

      this.newParam.keyword = ''
      this.advancedQuery = [
        {
          type: "and",
          keyword: "",
        },
        {
          type: "and",
          keyword: "",
        },
      ]
      this.neardQuery = [
        {
          spacing: 5,
          keyword: "",
        },
        {
          spacing: 5,
          type: "and",
          keyword: "",
        },
      ]
    },

    searchDataInBook () {
      this.newParam.keyword = this.newParam.keyword || this.bookParam.keyword
      if (!this.newParam.keyword) {
        return this.$message.warning("請輸入關鍵字")
      }
      if (this.newParam.searchType == 1) {
        this.newParam.advaList = this.advancedQuery.filter((item) => {
          return item.keyword !== ""
        })
      }
      if (this.newParam.searchType == 2) {
        this.newParam.advaList = this.neardQuery.filter((item) => {
          return item.keyword !== ""
        })
      }

      this.newParam.bookIds = this.bookParam.bookId
      this.newParam.searchAccuracyType = this.searchAccuracyType ? 1 : 0
      // console.log(this.newParam)
      essearch(this.newParam).then((data) => {
        if (data.code == 200) {
          this.catalogIdList = data.data.catalogIdList
          let page = []

          data.data.bookList.forEach((item) => {
            item.bookJuanList.forEach((val) => {
              val.bookPageList.forEach((v) => {
                v.juanName = val.juanName
                page.push(v)
              })

            })
          })
          // page = [...page, ...val.bookPageList]
          // console.log(page, 'page')
          this.searchInBook = page
          this.searchInBook.forEach((item, index) => {
            this.$set(item, 'xmlId', 0)
          })
          this.keywordStr = data.data.keywordStr
          // console.log(this.searchInBook,345);
          // console.log(this.sltOpearListId,678);
          //this.$root.$emit("clickNote",this.sltOpearListId);
          this.addLatest(2)
        }
      })
    },

    getList () {
      this.footNoteIndex = 0
      this.footNoteList = []
      //阅读记录
      this.addReadHistory()

      // delete this.bookParam.children;
      if (this.bookParam.formSearch && !this.bookParam.formSearchNotJump) {
        let pageJumpPar = {}
        pageJumpPar.pageId = this.bookParam.pageId
        pageJumpPar.passageXmlId = this.passageXmlId
        pageJumpPar.hitType = this.bookParam.hitType
        pageJumpPar.text = this.bookParam.text
        getBookContentInSearch(pageJumpPar).then((d) => {
          // console.log(d, 'dfaft')
          this.bookParam.xmlId = d.xmlId
          this.parentNodes = d.parentNodes || []
          this.sltOpearListId = d.xmlId
          this.xiaoOpearListId = d.xmlId
          if (this.searchIndex != -1) this.searchInBook[this.searchIndex].xmlId = d.xmlId
        })
      }
      // if (this.bookParam.source == "uc") { //个人中心笔记跳转
      //   this.sltOpearListId = this.bookParam.noteId
      // } else if (this.bookParam.source == "qa") {
      //   this.sltOpearListId = this.bookParam.feedbackId
      // }
      let { bookId, endPage } = this.bookParam
      // console.log(this.bookParam,'this.bookParam');
      getBookContent({
        // ...this.bookParam,
        // catalogId: this.bookParam.catalogId,
        juanNum: this.bookParam.juanNum,
        bookId,
        startPage: this.bookParam.beginPage || this.bookParam.startPage,
        endPage,
      }).then((d) => {
        // console.log(d.data, 'fsdf')
        if (d.code == 200) {
          this.addLatest(1)
          this.handleRequestData(d)
        } else {
          this.$message.error(d.msg)
        }


      })
    },
    handleRequestData (d) {
      // if (d.code == 501) {
      //   this.buyVisible = true
      //   return
      // }
      // let list = []
      // console.log(this.bookParam, 'd')
      // this.bookParam.catalogId = d.data[0].catalogId
      // this.$refs.leftCatalogList.setCurrentKey(this.bookParam.catalogId)
      this.secondTitle = ''
      // let selcatalogId = this.bookParam.clickCatalogId || d.data[0].catalogId;
      this.totalWordNumber = 0
      this.nodeList = JSON.parse(getDAesString(d.data))
      // console.log(this.nodeList, 'this.nodeList')
      this.nodeList.forEach((val) => {
        val.pageXmlJson = val.pageXmlJson || []
        // list.push(...val.pageXmlJson)
        val.child = val.pageXmlJson
      })


      this.findFootNoteByArr(this.nodeList)


      this.counterAllWord(this.nodeList)
      this.volume = this.nodeList[0].volume
      //左侧按钮点击
      if (this.bookParam.clickCatalogId) {
        const catalogTimer = setTimeout(() => {
          clearTimeout(catalogTimer)
          // console.log(selcatalogId,'selcatalogId');
          // console.log(bookParam.xmlId,'bookParam.xmlId');
          // console.log(this.bookParam.clickCatalogId, 'this.bookParam.clickCatalogId')
          this.leftCatelogIdJunpRight(this.bookParam.clickCatalogId)
          // this.bookParam.clickCatalogId = "";
        }, 1000 / 60)
      }
      const renderTimer = setTimeout(() => {
        clearTimeout(renderTimer)
        // 渲染区无法获取内容区所在，广播内容区域尺寸
        this.$root.$emit("contentBoxSize", this.contentBoxSize)

        // 获取当前区域内第一个标题

        this.getViewInCatelogInfo()
      }, 1000 / 60)


      // 搜索过来 跳转 滚动指定页
      this.bookParam.formSearchNotJump = false
      this.$forceUpdate()
      if (!this.bookParam.formSearch) {
        return
      }
      delete this.bookParam.formSearch
      // window.scrollTo(0, 0);
      // 初始化搜索结果
      if (this.opeatMenuSltType == 1 || this.opeatMenuSltType == 0) { this.gotoSearchDetail() }


      // 初始化笔记（如果点击笔记后）
      if (this.opeatMenuSltType == 2 || this.opeatMenuSltType == 3 || this.opeatMenuSltType == 5) { this.gotoSignDetail() }
    },

    // 搜索书内跳转
    gotoPage (item, index) {
      this.bookParam = {
        ...this.bookParam,
        ...item,
        pageId: item.id,
        keyword: this.keyword,
        formSearch: true,
        juanNum: item.juanNum,
        formSearchNotJump: false,
      }
      this.bookParam.catalogId = this.catalogueList[item.juanNum - 1].catalogId
      this.passageXmlId = item.passageXmlId
      this.searchIndex = index
      // console.log(this.bookParam, 'this.bookParam1235')
      this.getList()
      // });
    },
    viewDetail () {
      // !this.$route.query.keyword ||
      // if (this.keywordStr == this.$route.query.keyword) {
      //   this.gotoPage(item, index)
      // } else {
      // 搜索条件结束
      const query = {
        bookId: this.bookParam.bookId,
        bookName: this.bookName,
        // pageId: this.bookParam.pageId,
        juanNum: this.bookParam.juanNum,
        searchType: this.newParam.searchType,
        // keyword: item.hitKeyword,
        keyword: this.newParam.keyword,
        advancedQuery: JSON.stringify(this.advancedQuery),
        neardQuery: JSON.stringify(this.neardQuery),
        keywordstr: this.keywordStr,
        advaList: this.newParam.advaList,
        //numOfKeyword: item.numOfKeyword,
        hitType: this.bookParam.hitType ? this.bookParam.hitType : 1,
        formSearch: 1,
        //passageXmlId: '',
        //text: '',
        searchAccuracyType: this.searchAccuracyType   //繁简通检3.9新加
      }


      let routeData = this.$router.resolve({
        path: "/viewer",
        query,
      })

      window.open(routeData.href, "_blank")

    },
    gotoSearchDetail () {

      // setTimeout(() => {
      // console.log(this.bookParam);
      const page = this.bookParam.xmlId
      // const page = this.bookParam.text;
      // console.log(page, "page");
      const bookPage = this.bookParam.bookPage
      // const { sltNoteData = {} } = this.bookParam || {}
      // const ele = window["page" + page] || window["img-page" + bookPage]
      // ele &&
      //   ele.scrollIntoView({
      //     behavior: "smooth",
      //     block: "center",
      //     inline: "nearest",
      //   })

      // let hightarr = document.querySelectorAll(".hightText")
      // if (hightarr) {
      //   hightarr.forEach((item) => {
      //     item.removeAttribute("class")
      //   })
      // }
      this.$nextTick(() => {
        this.viewFootNoteIcon(page, bookPage)

        // 图标跳转
        // setTimeout(() => {
        let find =
          this.parentNodes.find((val) => {
            return val.name == "图" || val.name == "子图"
          }) || {}

        let zitu =
          this.parentNodes.find((val) => {
            return val.name == "子图"
          }) || {}

        let openImg = document.getElementById("img-page" + find.value)
        if (openImg) {
          openImg.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "center",
          })
          if (JSON.stringify(zitu) != '{}') {
            let zitucount = 0
            let zituactive = 0
            let zituarr = document.getElementById("page" + find.value).getElementsByClassName('zitu')
            // console.log(zituarr, 'zituarr')
            Array.from(zituarr).forEach((e, index) => {
              zitucount++
              if (e.id == 'zitu' + zitu.value) { zituactive = index }
            })

            let datuwidth = document.getElementById("img-page" + find.value).offsetWidth
            let datuheigth = document.getElementById("img-page" + find.value).offsetHeight

            let zituwidth = Math.ceil(datuwidth / zitucount)
            let zituleft = zituwidth * (zituactive + 1)
            // console.log(zituwidth, zituleft)
            document.getElementById("page" + find.value).style.position = 'relative'
            let zituobj = document.getElementById("zitu" + zitu.value)
            zituobj.style.width = zituwidth + 'px'
            zituobj.style.height = datuheigth + 'px'
            zituobj.style.position = 'absolute'
            zituobj.style.top = 0
            zituobj.style.left = zituleft + 'px'
            zituobj.style.border = "1px solid #ffff00"
            // zituobj.style.cssText = `width:${zituwidth}'px';height:${datuheigth}'px';top:'0px';left:${zituleft}'px'`


          } else {

            openImg.style.border = "1px solid #ffff00"
          }

          // this.$nextTick(() => {
          //   openImg.click()
          // })
        }
        // }, 1000)



        let tempsid = ""
        let eles = ""
        // this.$nextTick(() => {
        if (this.opeatMenuSltType == 0) {
          //校记跳转
          tempsid = this.xiaoOpearListId
          eles = document.getElementById("x" + tempsid)
          // console.log(tempsid, 'x---')
        } else {
          //搜索跳转
          tempsid = this.passageXmlId
          eles = document.getElementById("r1--" + tempsid)
        }

        if (tempsid) {
          // const eles = rightnode['r'+tempsid]
          eles &&
            eles.scrollIntoView({
              behavior: "smooth",
              block: "center",
              inline: "nearest",
            })
        }
        // })

      })

      // let find =
      //   this.parentNodes.find((val) => {
      //     return val.name == "图" || val.name == "子图"
      //   }) || {}
      // console.log(find, 'find')
      // setTimeout(() => {
      //   let openImg = window["img-page" + find.value]
      //   if (openImg) {
      //     openImg.scrollIntoView({
      //       behavior: "smooth",
      //       block: "center",
      //       inline: "center",
      //     })
      //     openImg.click()
      //   }
      // }, 1000 / 60)

      //右侧搜索滚动到相应位置

      // }, 1000)
      // }, 1000 / 60)
    },
    gotoSignDetail (paraxmlid) {


      this.$nextTick(() => {
        const { sltNoteData = {} } = this.bookParam || {}
        //问题反馈xmlId
        // let qaxmlid = ""
        // if (sltNoteData.pos) qaxmlid = JSON.parse(sltNoteData.pos).xmlId
        const xmlId = sltNoteData.xmlId || sltNoteData.feedbackPage || paraxmlid
        console.log(xmlId, window["page" + xmlId], 'xmlId')
        if (window["page" + xmlId]) {
          console.log(xmlId, 'xmlId')
          window["page" + xmlId].scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "nearest",
          })
        }
      })
      // window['img'+page]&&window['img'+page].click();
      // if (window.hightText) {
      //   window.hightText.removeAttribute("id");
      // }
      // let hightarr = document.querySelectorAll(".sehightText");
      //  if (hightarr) {
      //   hightarr.forEach((item) => {
      //     item.removeAttribute("class");
      //   });
      // }

      // const allText = window["page" + xmlId].innerText;
      // let tempnoteTarget =
      //   sltNoteData.noteTarget || sltNoteData.contentName;
      // if (tempnoteTarget) {
      //   let tempnoteTargetarr = tempnoteTarget.split(" ");
      //   let mess = window["page" + xmlId].innerHTML;
      //   let rxmlId = xmlId;
      // let rxmlId = 4684;
      // console.log(rxmlId,'rxmlId');
      // do {
      //   if(tempnoteTargetarr[i].length==0) continue;
      //   let allText = window["page" + rxmlId].innerHTML;
      //   window["page" + rxmlId].innerHTML = allText.replace(
      //     new RegExp(tempnoteTargetarr[i]), //笔记与反馈公用高亮逻辑
      //     (text) => {
      //       return `<span class="hightText">${text}</span>`;
      //     }
      //   );
      //   // console.log(tempnoteTargetarr[i], i, rxmlId, "b");
      //   i--;
      //   if (mess.indexOf("data-id") === -1) rxmlId -= 2;
      // } while (i >= 0);

      //   for(let i = tempnoteTargetarr.length - 1;i>=0;i--){
      //       if(tempnoteTargetarr[i].length==0){
      //         if (mess.indexOf("data-id") === -1){ rxmlId -= 2;}
      //         continue;
      //       }else{
      //       let allText = window["page" + rxmlId].innerHTML;
      //       window["page" + rxmlId].innerHTML = allText.replace(
      //         new RegExp(tempnoteTargetarr[i]), //笔记与反馈公用高亮逻辑
      //         (text) => {
      //           return `<span class="hightText">${text}</span>`;
      //         }
      //       );
      //       if (mess.indexOf("data-id") === -1){ rxmlId -= 2;}
      //       }
      // };

      // }

      // this.bookParam.sltNoteData = {};

      // window["page" + xmlId].innerHTML = allText.replace(
      //   new RegExp(sltNoteData.noteTarget || sltNoteData.contentName), //笔记与反馈公用高亮逻辑
      //   (text) => {
      //     return ` <span class="hightText">${text}</span>`;
      //   }
      // );

      // }, 1000 / 60);

    },
    counterAllWord (data) {
      data.forEach((item) => {
        if (item.content) {
          this.totalWordNumber += item.content.length
        }
        if (item.child && item.child.length) {
          this.counterAllWord(item.child)
        }
      })
      // this.statisticsFonts = '<p>當前頁共計字數： '+this.totalWordNumber+'</p>';
    },
    findFootNote (data, catalogId = 0) {
      let footNote = []
      // console.log(data, '脚注')

      data.forEach((v) => {
        if (v.type && (v.type === "脚注-注")) {
          let id = 0

          this.footNoteIndex++
          let str = ""
          v.child.forEach((v, i) => {
            if (i == 0) id = v.id
            if (v.label == '脚注段落') {  //新增脚注段落
              v.child.forEach((vv, ii) => {
                if (vv.label == 'text' || vv.label == '字图') {
                  str =
                    str +
                    (vv.label === "字图"
                      ? `<img src=${this.baseImgPath + this.bookName + "/" + vv.content
                      }/>`
                      : this.brightenKeyword(vv.content, this.keyword))

                } else if (vv.type == '脚注小字') {
                  str += `<span  style="font-size: ${12 * (1 + this.changefontSize / 100)}px">`
                  vv.child.forEach((vv, ii) => {
                    if (vv.label == 'text') {
                      str =
                        str +
                        (vv.label === "字图"
                          ? `<img src=${this.baseImgPath + this.bookName + "/" + vv.content
                          }/>`
                          : this.brightenKeyword(vv.content, this.keyword))

                    }
                  })
                  str += "</span>"
                }
              })
              str += "<br/><br/>"
            } else if (v.type == '脚注小字') {
              str += `<span  style="font-size: ${12 * (1 + this.changefontSize / 100)}px">`
              v.child.forEach((vv, ii) => {
                if (vv.label == 'text') {
                  str =
                    str +
                    (vv.label === "字图"
                      ? `<img src=${this.baseImgPath + this.bookName + "/" + vv.content
                      }/>`
                      : this.brightenKeyword(vv.content, this.keyword))

                }
              })
              str += "</span>"

            } else {
              str =
                str +
                (v.label === "字图"
                  ? `<img src=${this.baseImgPath + this.bookName + "/" + v.content
                  }/>`
                  : this.brightenKeyword(v.content, this.keyword))
            }
          })
          this.footNoteList.push({
            content: str,
            id,
            catalogId,
          })
        }
        else if (v.child && v.child.length) {
          if (v.catalogId) { catalogId = v.catalogId }
          this.findFootNote(v.child, catalogId)
        }
        // console.log(this.footNoteList)
      })

      //右侧校记列表滚动位置
      // this.footNoteList.forEach((item) => {
      //   if (item.content && item.content.indexOf("#3366CC") > -1) {
      //     this.xiaoOpearListId = item.id;
      //   }
      // });
    },
    findFootNoteByArr (data, catalogId = 0) {
      data.forEach((v) => {
        if (v.type && (v.type === "脚注-注")) {
          let id = 0
          this.footNoteIndex++
          // let str = ""
          let arr = []
          v.child.forEach((v, i) => {
            if (i == 0) id = v.id
            if (v.label == '脚注段落') {  //新增脚注段落
              v.child.forEach((vv, ii) => {
                if (vv.label == 'text' || vv.label == '字图' || vv.label == '图') {
                  if (vv.label == '图') {
                    let widthsel = ''
                    let hightsel = ''
                    if (vv.size) {
                      let sizearr = vv.size.split(",")
                      widthsel = sizearr[0] ? sizearr[0] + 'px' : 'auto'
                      hightsel = sizearr[1] ? sizearr[1] + 'px' : 'auto'
                    }
                    arr.push({ label: "图", content: vv.content, widthsel, hightsel })
                  } else if (vv.label == "字图") {
                    arr.push({ label: "字图", content: vv.content, size: vv.size })
                  } else {
                    arr.push({ label: "xiaoji", content: vv.content })
                  }

                } else if (vv.type == '脚注小字') {
                  vv.child.forEach((vv, ii) => {
                    if (vv.label == 'text' || vv.label == '字图' || vv.label == '图') {
                      if (vv.label === "图") {
                        let widthsel = ''
                        let hightsel = ''
                        if (vv.size) {
                          let sizearr = vv.size.split(",")
                          widthsel = sizearr[0] ? sizearr[0] + 'px' : 'auto'
                          hightsel = sizearr[1] ? sizearr[1] + 'px' : 'auto'
                        }
                        arr.push({ label: "图", content: vv.content, widthsel, hightsel })
                      } else if (vv.label == "字图") {
                        arr.push({ label: "字图", content: vv.content, size: vv.size })
                      } else {
                        arr.push({ label: "脚注小字", content: vv.content })
                      }

                    }
                  })
                }
              })
              arr.push({ label: "脚注段落" })
            } else if (v.type == '脚注小字') {
              v.child.forEach((vv, ii) => {
                if (vv.label == 'text' || vv.label == '字图' || vv.label == '图') {
                  if (vv.label === "图") {
                    let widthsel = ''
                    let hightsel = ''
                    if (vv.size) {
                      let sizearr = vv.size.split(",")
                      widthsel = sizearr[0] ? sizearr[0] + 'px' : 'auto'
                      hightsel = sizearr[1] ? sizearr[1] + 'px' : 'auto'
                    }
                    arr.push({ label: "图", content: vv.content, widthsel, hightsel })
                  } else if (vv.label == "字图") {
                    arr.push({ label: "字图", content: vv.content, size: vv.size })
                  } else {
                    arr.push({ label: "脚注小字", content: vv.content })
                  }

                }
              })

            } else {
              if (v.label === "图") {
                let widthsel = ''
                let hightsel = ''
                if (v.size) {
                  let sizearr = v.size.split(",")
                  widthsel = sizearr[0] ? sizearr[0] + 'px' : 'auto'
                  hightsel = sizearr[1] ? sizearr[1] + 'px' : 'auto'
                }
                arr.push({ label: "图", content: v.content, widthsel, hightsel })
              } else if (v.label == "字图") {
                arr.push({ label: "字图", content: v.content, size: v.size })
              } else if (v.label == '边框') {
                console.log(v.child, catalogId, id, '边框')
                arr.push({ label: "边框", content: v.child })
              } else {
                arr.push({ label: "xiaoji", content: v.content })
              }
            }
          })
          this.footNoteList.push({
            content: arr,
            id,
            catalogId,
          })
        }
        else if (v.child && v.child.length) {
          if (v.catalogId) { catalogId = v.catalogId }
          this.findFootNoteByArr(v.child, catalogId)
        }
        // console.log(this.footNoteList)
      })
    },

    findDuanluoNOte (data, type = 1, str = '') {
      // if(v.label == '脚注段落'){  //新增脚注段落

      str += (type == 1) ? "" : '<span class="font-12">'
      data.child.forEach((vv, ii) => {
        if (vv.label == 'text') {
          str =
            str +
            (vv.label === "字图"
              ? `<img src=${this.baseImgPath + this.bookName + "/" + vv.content
              }/>`
              : this.brightenKeyword(vv.content, this.keyword))

        } else if (vv.type == '脚注小字') {
          str += this.findDuanluoNOte(vv, 2)
        }
      })
      str = str + (type == 1) ? "" : '</span>'
      console.log(str, 'duanluo')
      return str
      // }else{
      //新增脚注段落结束

    },

    // 跳到脚注动画
    // 获取书目菜单
    getBookMenu () {
      getBookCatalogue({ parentId: 0, bookId: this.bookParam.bookId }).then(
        (d) => {
          let catalogId = ""
          if (this.bookParam.catalogId) {
            catalogId = this.bookParam.catalogId
          } else {
            d.data.forEach((rows, index) => {
              // rows.juanNum = index + 1;
              if (rows.juanNum == this.bookParam.juanNum) {
                catalogId = this.bookParam.catalogId = rows.catalogId
              }
            })
            // console.log(this.bookParam.catalogId, 'catalogId')
          }
          const firstCata = d.data[0]

          // 后台字段命名比较乱 beginPage 、startPage一个意思
          this.bookParam.beginPage = this.bookParam.startPage =
            this.bookParam.startPage ||
            this.bookParam.beginPage ||
            firstCata.beginPage ||
            firstCata.startPage
          this.bookParam.endPage = this.bookParam.endPage || firstCata.endPage
          this.catalogueList = d.data
          // catalogId = this.rightCatalogId = this.bookParam.catalogId
          // this.bookParam.clickCatalogId = this.bookParam.catalogId = catalogId
          this.rightCatalogId = catalogId
          // 打开默认项

          this.$nextTick(() => {
            const list = this.$refs.leftCatalogList
            list.setCurrentKey(catalogId)
            this.expandedTree(list.store.nodesMap[catalogId])
            window["tree" + catalogId] &&
              window["tree" + catalogId].scrollIntoView({
                behavior: "smooth",
                block: "center",
                inline: "nearest",
              })
          })
          // setTimeout(() => {

          //   window["tree" + d] &&
          //     window["tree" + d].scrollIntoView({
          //       behavior: "smooth",
          //       block: "center",
          //       inline: "nearest",
          //     })

          // }, 1000 / 30)
          this.getList()
        }
      )
    },

    addBookNoteData () {
      const { noteId, noteContent, noteTarget } = this.noteContent
      if (!noteTarget) {
        this.$message.error("請選擇正文内容")
        return
      }
      if (!noteContent) {
        this.$message.error("請輸入筆記内容")
        return
      }
      // this.noteContent.noteContent = noteTarget + this.tempnoteContent;
      if (noteId) {
        return editBookNote({
          noteId,
          noteTarget,
          noteContent,
        }).then((d) => {
          if (d.code == 200) {
            this.$message.success("修改成功")
          } else {
            this.$message.error("修改失败")
          }
          this.getBookNoteData()
          this.noteContent = {}
        })
      }
      // console.log(this.selectionData, this.selectNoteData, 'this.selectNoteData44455')
      const { data = {} } = this.selectionData
      // console.log(data, 'data')
      const { bookId, catalogId } = this.bookParam

      const { beginPage, endPage, catalogName } =
        this.catalogueList[this.bookParam.juanNum - 1]
      this.noteContent = {
        noteType: 1,

        ...this.noteContent,
        beginPage,
        endPage,
        catalogName: this.secondTitle || catalogName,
        juanName: catalogName,
        bookId: this.bookParam.bookId,

        notePage: data.page || bookId, // mock
        xmlId: data.id || bookId, // mock
        juanNum: this.bookParam.juanNum,
        notePos: JSON.stringify({ catalogId }),
      }
      // console.log(this.noteContent, "this.noteContent")
      addBookNote(this.noteContent).then((d) => {
        if (d.code == 200) {
          this.$message.success("新增成功")
          this.getBookNoteData()
          // this.$nextTick(() => {
          //   this.sltOpearListId = this.myBookNote[0].noteId
          // })
          this.noteContent = {}
          this.selectNoteData = {}
        } else {
          this.$message.error("新增失败")
        }


      })
    },
    addBookQa () {
      const { data = {} } = this.selectionData
      const { bookId, catalogId } = this.bookParam
      const { beginPage, endPage, catalogName } =
        this.catalogueList[this.bookParam.juanNum - 1]
      // console.log(data, 'sel')
      // return
      // const slt = this.selectionData
      // console.log(this.selectionData, 'addBookQa')
      // return;
      // console.log(this.bookParam);
      this.qaContent = {
        ...this.qaContent,
        beginPage,
        endPage,
        catalogName,
        bookId: this.bookParam.bookId,
        feedbackPage: data.id || bookId, // mock
        juanNum: this.bookParam.juanNum,

        // contentName: slt && slt.text,
        pos: JSON.stringify({ catalogId, pageId: data.page }),
      }
      // console.log(this.qaContent, 'this.qaContent')
      addBookQa(this.qaContent).then(() => {
        this.getBookQaData()
        // this.$nextTick(() => {
        // this.sltOpearListId = this.myBookQa[this.myBookQa.length - 1].feedbackId
        // })
        this.$message.success("新增成功")
        this.qaContent = {}
        this.selectNoteData = {}
      })
    },



    getBookNoteData (noteType = 1) {
      getNoteListNew({
        'bookId': this.bookParam.bookId,
        'orderByColumn': 'createTime',
        'isAsc': 'desc',
        'pageNum': 1,
        'pageSize': 10000,
        noteType
      }).then((d) => {
        // console.log(d, 'dd')
        if (noteType == 2) {
          this.myBookMark = d.rows
          // this.filtMyBookMark()
        } else {
          this.myBookNote = d.rows
          if (this.$route.query.source == 'uc') {

            let flag = false
            try {
              d.rows.forEach((item) => {
                if (flag) throw new Error()
                if (item.noteId == this.bookParam.noteId) {

                  this.findNoteInBook(item)//笔记跳转
                  flag = true
                }
              })
            } catch (e) { }
            // this.findNoteInBook(this.myBookNote[0])//笔记跳转
          } else if (this.$route.query.source == 'note') {
            getNoteDetail(this.bookParam.noteId).then((d) => {
              if (d.code == 200) {
                this.findNoteInBook(d.data)//笔记跳转
              }

            })
          }
        }


      })
    },
    delBookNote (id, noteType = 1) {
      if (id == '') id = this.sltOpearListId
      if (id == '') {
        this.$message.error("請在右側書簽列表選擇要刪除的書簽")
        return
      }
      deletBookNote({ noteId: id }).then(() => {
        this.getBookNoteData(noteType)
        if (id == this.sltOpearListId) {
          this.noteContent = {}
          this.sltOpearListId = ''
          this.selectNoteData = {}
          this.underline = {}
          this.noteOrQa = {}
        }

        this.$message.success("刪除成功")
      })
    },
    // 书签
    addBookMark () {
      if (!this.selectionData.text) {
        this.$message.error("請選擇正文内容")
        return
      }

      const { data = {} } = this.selectionData
      // console.log(data, 'data')
      const { bookId, catalogId } = this.bookParam

      const { beginPage, endPage, catalogName } =
        this.catalogueList[this.bookParam.juanNum - 1]
      this.noteContent = {
        noteType: 2,
        noteTarget: this.selectionData.text,
        beginPage,
        endPage,
        catalogName: this.secondTitle || catalogName,
        juanName: catalogName,
        bookId: this.bookParam.bookId,
        notePage: data.page || bookId, // mock
        xmlId: data.id || bookId, // mock
        juanNum: this.bookParam.juanNum,
        notePos: JSON.stringify({ catalogId }),
      }
      // console.log(this.noteContent, "this.noteContent")
      addBookNote(this.noteContent).then((d) => {
        // console.log(d)
        if (d.code == 200) {
          this.$message.success("新增成功")
          this.getBookNoteData(2)
          this.sltOpearListId = ''
          // this.noteOrQa = { noteOrQa: this.selectionData.text, catalogId: catalogId, xmlId: data.id, type: 2 }
          this.noteContent = {}
        } else {
          this.$message.error("新增失败")
        }


      })

    },

    getBookQaData () {
      getBookQaList({ bookId: this.bookParam.bookId }).then((d) => {
        // console.log(d, 'dfsdffd')
        if (d.code == 200) {
          this.myBookQa = d.rows
          if (this.$route.query.source == 'qa') {

            // let flag = false
            // try {
            //   d.rows.forEach((item) => {
            //     if (flag) throw new Error()
            //     if (item.feedbackId == this.bookParam.feedbackId) {


            //       qaitem = item
            //       flag = true
            //     }
            //   })
            // } catch (e) { }
            getQaDetail(this.bookParam.feedbackId).then((d) => {
              if (d.code == 200) {
                this.findNoteInBook(d.data)//笔记跳转
              }

            })



          }
        }

      })
    },
    deleteBookQaData (id) {
      deleteBookQaList(id).then((d) => {
        if (d.code != 200) {
          return
        }
        if (id == this.sltOpearListId) {
          this.qaContent = {}
          this.sltOpearListId = ''
          this.selectNoteData = {}
          this.noteOrQa = {}
          this.underline = {}
        }
        this.getBookQaData()

        this.$message.success("刪除成功")
      })
    },

    // 笔记定位
    findNoteInBook (item, type = 1) {
      //type=2 书签高亮
      // this.sltOpearListId = item.noteId;
      // console.log(item, 'item')
      const { endPage, beginPage, juanNum, notePos, pos, notePage, xmlId, feedbackPage } =
        item

      // this.bookParam.catalogId = this.rightCatalogId
      // this.$set(this.bookParam, 'catalogId', this.rightCatalogId)
      // console.log(this.bookParam.catalogId, 'this.bookParam.catalogId')

      // this.bookParam.xmlId = xmlId || feedbackPage // 笔记与问题反馈公用一个定位逻辑 但字段名不一样
      // console.log(item,'item');
      this.bookParam.sltNoteData = item

      this.selectNoteData = item
      this.sltOpearListId = item.noteId || item.feedbackId
      if (type != 2) {
        this.noteOrQa = { noteOrQa: item.noteTarget || item.contentName, type: type }
      }
      // console.log(this.bookParam, 'this.bookParam')
      if (notePos) {
        this.rightCatalogId = JSON.parse(notePos).catalogId
        this.bookParam = { ...this.bookParam, catalogId: this.rightCatalogId }
      }
      if (pos) {
        this.rightCatalogId = JSON.parse(pos).catalogId
        this.bookParam = { ...this.bookParam, catalogId: this.rightCatalogId }
      }
      // this.bookParam.catalogId = this.rightCatalogId
      //高亮传值到xmlTree
      // this.noteOrQa = item.noteTarget || item.contentName

      // 获取高亮元素并清除
      // const isHightLight = document.querySelectorAll(".sign-hightligh");
      // if (window.hightText) {
      //   window.hightText.removeAttribute("id");
      // }
      // let hightarr = document.querySelectorAll(".hightText");
      // if (hightarr) {
      // hightarr.forEach((item) => {
      // console.log(item,'hightarr');
      // item.removeAttribute("class");
      // console.log(item,'hightarr1');
      // item = item.innerText;
      // console.log(item,'hightarr2');
      // let itemhtml = document.createTextNode(item.innerHTML);
      // item.insertBefore(itemhtml,item);
      // item.remove();
      // console.log(itemhtml);
      // item = item.innerText;
      // return item.innerText;
      // });
      // console.log(hightarr,'hightarr');
      //   for (let index = 0; index < hightarr.length; index++) {
      //     hightarr[index].outerHTML = hightarr[index].innerHTML;
      //   }
      // }
      // for (let index = 0; index < isHightLight.length; index++) {
      //   isHightLight[index].style.background = "transparent";
      //   isHightLight[index].style.color = "";
      //   isHightLight[index].classList.remove("sign-hightligh");
      // }
      // console.log(juanNum,'juanNum');
      // console.log(this.bookParam, 'this.bookParam')
      if (
        !(
          this.bookParam.juanNum == juanNum
        )
      ) {

        this.bookParam.endPage = endPage
        this.bookParam.beginPage = beginPage

        this.bookParam.juanNum = juanNum
        this.bookParam.formSearch = true
        this.bookParam.formSearchNotJump = true

        this.getList()
      }
      else {
        // this.getViewInCatelogInfo()
        this.gotoSignDetail()
      }
    },

    // 左侧树桩点击
    treeNodeClick (item, node, c) {
      // console.log(item, node, c, 'nodec')
      // this.secondTitle = '';
      // console.log(item, 'item')

      this.bookParam.clickCatalogId = item.catalogId
      // this.rightCatalogId = this.bookParam.catalogId = this.bookParam.clickCatalogId = item.catalogId
      if (node.level == 1) {
        this.bookParam = { ...this.bookParam, ...item }
        // console.log(item,'item');
        // this.secondTitle = '';
        // this.bookParam.clickCatalogId = (item.children.length > 0) ? item.children[0].catalogId : item.catalogId
        // this.bookParam.clickCatalogId = item.catalogId
        // console.log(this.bookParam, 'this.bookParam')
        this.noteOrQa = {}
        this.underline = {}
        this.getList()
        // window.scrollTo(0, 0)
      } else {
        if (item.juanNum !== this.bookParam.juanNum) {
          // this.bookParam.clickCatalogId = item.catalogId
          return this.handleCurrentChange(item.juanNum)
        }
        this.leftCatelogIdJunpRight(item.catalogId, 'item.catalogId')
      }

    },

    // 点击左侧数 内容区域滚动
    leftCatelogIdJunpRight (catalogId) {
      let ele = window["catalogId" + catalogId]
      if (!ele) {
        // console.log(ele,'ele');
        return
      }
      // console.log(ele,'ele');
      if (ele.length) {
        ele = ele[0]
      }
      // console.log(ele,'ele');
      this.$nextTick(() => {
        ele.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
        })
      })
    },
    selectMenuType (e, item, index) {
      e.stopPropagation()
      this.isOperaText = true
      // item.onClick(item)
      this.menuListPositon = null

      if (item.index !== undefined) {
        this.opeatMenuSltType = item.index
      }
      item.onClick && item.onClick(item)
    },

    // 设置背景色
    setViewBgColor (e, key) {
      e.stopPropagation()

      this.themeId = key
      this.isSelectColor = false
    },

    handleCurrentChange (val) {
      // console.log(this.catalogueList[val - 1]);
      this.bookParam = {
        ...this.bookParam,
        ...this.catalogueList[val - 1],
        juanNum: val,
        formSearchNotJump: true
      }
      delete this.bookParam.children
      this.getList()
    },
    clearmenuListPositon () {
      if (this.menuListPositon) {
        // let elemenu = document.getElementById('popListBox');
        // elemenu.addEventListener('mouseenter',function(){
        //   console.log('rere');
        //   return;
        // })
        // console.log('reeed');
        this.menuListPositon = null
      }
      // console.log('xxx');
    },
    getSelectData (e, data, text, downData) {
      // console.log(e, data, text, downData, 'eee')

      if (!text) {
        this.menuListPositon = null
        this.selectionData = {}

        return
      }
      text = text.substring(0, 100)
      data.sign = data.sign || {}
      data.sign[text] = text


      this.selectionData = {
        text,
        data,
        downData,
      }
      // console.log(this.selectionData, 'this.selectionDatathis.selectionData')
      this.selectNoteData = {
        noteTarget: text,
        notePage: data && data.content,
      }
      this.menuListPositon = {
        x: e.clientX,
        y: e.clientY - 30,
      }

      // 纠正错位 纵向
      setTimeout(() => {
        if (
          e.clientY + window.popListBox.clientHeight >
          window.contentBox.clientHeight + 135
        ) {
          this.menuListPositon.y =
            window.contentBox.clientHeight +
            135 -
            window.popListBox.clientHeight - 30
          this.$forceUpdate()
        }

      })

    },
    // rightClick (MouseEvent) {

    // },
    //暫不支持跨段跨標簽檢索
    JansuoXianzhi (text) {
      if (text.indexOf('\n') != -1 || text.indexOf('     ') != -1) {
        this.$message.error("暫不支持跨段跨標簽檢索")
        return false
      } else {
        return true
      }
    },
    //
    getClientInfo (e, ele) {
      this.dragEle = ele
      // return console.log( this.$refs[ele],this.$refs.leftDragCate,ele)
      this.rightOpera = {
        width: this.$refs[ele].$el
          ? this.$refs[ele].$el.clientWidth
          : this.$refs[ele].clientWidth,
        startX: e.clientX,
        isMouseDown: true,
      }
    },
    moveClient (e, ele) {
      // console.log(e,ele,'eele');
      if (!this.rightOpera.isMouseDown) {
        return
      }
      e.stopPropagation()
      e.preventDefault()

      const { startX } = this.rightOpera
      let offsetWidth = e.clientX - startX
      if (this.dragEle === "leftDragCate") {
        offsetWidth = startX - e.clientX
      }

      let el = this.$refs[this.dragEle].$el || this.$refs[this.dragEle]
      el.style.width = this.rightOpera.width - offsetWidth + "px"
      clearTimeout(this.resizeTimer)

      this.resizeTimer = setTimeout(() => {
        this.contentBoxSize = {
          // width: window.bookContentBox.clientWidth - 64,
          width: window.bookContentBox.clientWidth * 0.85,
          height: window.bookContentBox.clientHeight - 64,
        }
        this.$root.$emit("contentBoxSize", this.contentBoxSize)
      }, 500)
    },
    mouseUp () {
      this.rightOpera = {
        isMouseDown: false,
      }
    },
  },

};
</script>

<style lang="less" scoped>
/deep/.viewer-tooltip {
  writing-mode: rl;
}
/deep/.el-button--small,
.el-button--small.is-round {
  padding: 8px 15px;
}
.xinghao {
  // color: #3366cc;
  color: #e60012;
}
.custom-tree-node {
  display: flex;
  align-items: center;
  justify-content: start;
}
.cunmuicon {
  // display: inline-block;
  cursor: pointer;
  width: 24px;
  height: auto;
  // margin: 0 auto;
  // background-image: url(/static/icon/hreficonnew.png);
  // background-size: cover;
  // position: absolute;
  // top: -16px;

  img {
    width: 100%;
    height: 100%;
  }
}

//  onselectstart="return false"
// .user-sel{
//   -moz-user-select:none; /* Firefox私有属性 */
//     -webkit-user-select:none; /* WebKit内核私有属性 */
//     -ms-user-select:none; /* IE私有属性(IE10及以后) */
//     -khtml-user-select:none; /* Khtml内核私有属性 */
//     -o-user-select:none; /* Opera私有属性 */
//     user-select:none; /* CSS3属性 */
// }
.overhand {
  cursor: pointer;
}
.label {
  font-size: 14px;
}
.head {
  background: #f0f8ff;
  padding: 1rem;
  .nexticon {
    width: 24px;
    cursor: pointer;
  }
  .leftnext {
    margin-right: 8px;
  }
  .xuanzhuan {
    transform: rotate(180deg);
    // margin-left: 8px;
  }
  > .justify-between {
    width: 66rem;
    margin: 0 auto;
  }

  .icon {
    width: 1rem;
    // height: 1.2rem;
    cursor: pointer;
    margin-right: 0.7rem;
  }

  .bg-color-box {
    position: relative;
    .colors-box {
      position: absolute;
      left: 0;
      top: 3rem;
      width: 100px;
      z-index: 9999;

      /deep/ .el-card__body {
        padding: 0;
        width: 100%;
        > div {
          width: 100px;
          height: 24px;
          line-height: 24px;

          cursor: pointer;
        }
      }
    }
  }
}
.tree-list {
  /deep/.el-tree--highlight-current
    .el-tree-node.is-current
    > .el-tree-node__content {
    background-color: #e2f1ff;
  }
  // flex: 1;
  padding: 24px 12px;
  width: 250px;
  background: rgba(112, 112, 112, 0.04);
  height: ~"calc((100vh - 6.9rem))";
  // height: ~"calc((100vh - 11.29rem))";
  overflow: hidden;
  position: relative;
  .drag-box {
    left: initial;
    right: 0;
  }
  img {
    width: 24px;
  }

  .tree {
    margin: 0 5px 12px;
    font-size: 1.2rem;
    color: #1b1b1b;
    padding: 0 0 1rem;
    // position: fixed;
    width: 100%;
    height: ~"calc(100% - 45px)";
    // border-bottom: 0.1rem solid #ccc;
    .quanKuBtn {
      width: 220px;
      // margin: 8px auto 14px;
      margin-top: 8px;
      margin-bottom: 14px;
    }
    .treeoutdiv {
      width: 100%;
      height: 95%;
      overflow-y: auto;
      overflow-x: hidden;
      // padding-bottom: 3rem;
    }
    .padding-left {
      padding-left: 1.6rem;
    }
    .title {
      margin-bottom: 0.5rem;
    }
    .right-icon {
      font-size: 1.2rem;
      color: #9999;
      cursor: pointer;
    }
  }

  /deep/ .el-tree {
    background: transparent;
  }
}

.menu-pop-list {
  position: fixed;
  /deep/ .el-card__body {
    padding: 0.83rem;
    width: 100%;
    > div {
      font-size: 0.94rem;
      color: #666;
      padding: 0.2rem 0;
      margin-bottom: 0.36rem;
      display: flex;
      align-items: center;
      cursor: pointer;
      &:hover {
        color: #3366cc;
        background: rgba(51, 102, 204, 0.25);
      }
      img {
        width: 0.9rem;
        height: 1rem;
        margin-right: 0.73rem;
      }
    }
  }
}

.open-icon {
  position: absolute;
  right: 24px;
  top: 24px;
  width: 24px;
  z-index: 9;
  cursor: pointer;
}

.text-opera {
  width: 24rem;
  height: ~"calc(100vh - 7rem)";
  position: relative;

  /deep/ .el-card__body {
    padding: 24px 12px;
    height: 100%;
    display: flex;

    background: #eef3fd;
    position: relative;
    .recover-btn {
      position: absolute;
      left: 12px;
      top: 24px;
      width: 24px;
      cursor: pointer;
    }

    .left-menu {
      width: 3rem;
      height: 100%;
      display: flex;
      padding-top: 1.25rem;
      flex-direction: column;
      justify-content: center;
      align-items: flex-end;

      .item {
        width: 3rem;
        margin-bottom: 24px;
        padding: 0.36rem;
        border-radius: 0.2rem;
        cursor: pointer;
        font-size: 0.94rem;
        color: #3366cc;
        > span {
          display: none;
        }

        &.active {
          background: #fff;
          > span {
            display: inline;
          }
        }

        img {
          width: 2rem;
          height: auto;
          margin-bottom: 0.3rem;
        }
      }
    }

    .opear-box {
      background: #fff;
      border-radius: 0.1rem;
      padding: 1rem;

      overflow: auto;
      .scalicon {
        width: 1rem;
        // height: 1.2rem;
        cursor: pointer;
        // margin-right: 0.7rem;
      }
      .search-box {
        .left-input-box {
          width: 100%;
        }
      }
      .note-ipt-box {
        position: relative;
      }
      .newborder {
        padding: 15px;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        line-height: 1.5;
        span {
          display: inline-block;
          margin-bottom: 10px;
          font-size: 14px;
          color: #bbb;
          border-bottom: 1px solid #dcdfe6;
          padding-bottom: 10px;
        }
        textarea {
          border-width: 0;
          padding: 0;
        }
      }
      .note-ipt-icon {
        width: 1.15rem;
        height: 1.15rem;
        position: absolute;
        right: 0.78rem;
        bottom: 0.47rem;
        cursor: pointer;
      }

      .list-box {
        margin-top: 1rem;
        cursor: pointer;
        height: ~"calc(100% - 26px-1rem)";
        overflow: hidden;
        > div {
          height: 100%;
          > div:nth-child(2) {
            height: ~"calc(100% - 42px)";
            > div {
              height: 100%;
            }
          }
        }
        .old-list {
          padding: 0;
          // font-weight: bold;
          word-break: normal;
          text-align: justify;
          height: 100%;
          overflow: auto;
          > li {
            display: flex;
            padding: 0.4rem 0.3rem 0;
            &.active,
            &:hover {
              background: #edf2fc;
              .list-content {
                color: #3366cc;
              }
            }

            .sort {
              font-size: 1.04rem;
              color: #e60012;
              margin-right: 1rem;
            }
            .list-content {
              flex: 1;
              flex-grow: 1;
              font-size: 16px; //0.94rem
              line-height: 1.41rem;
              color: #313131;
              border-bottom: 0.04rem solid #cccccc;
              margin-bottom: 1.8rem;
              > img {
                width: 1rem;
              }

              .icon {
                width: 0.83rem;
                height: auto;
                margin: 0.5rem 0;
                cursor: pointer;
              }
              span img {
                height: 16px;
                width: auto;
              }
            }
          }
        }
      }

      /deep/ .el-collapse-item__header {
        font-size: 0.73rem;

        color: #3366cc;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/viewer.vue